module.exports = __webpack_public_path__ + "static/media/alastair-illustration.8d5af626.jpeg";